export default __webpack_public_path__ + "static/media/naidi-3.a289fda5.svg";